export interface GetCvPortalCandidateTokenForCurrentUserParameters {
  idConcern: number;
}

export type getCvPortalCandidateTokenForCurrentUser = (
  args: GetCvPortalCandidateTokenForCurrentUserParameters
) => Promise<CVPortalCandidateToken>;

export const getCvPortalCandidateTokenForCurrentUser: getCvPortalCandidateTokenForCurrentUser =
  (args) => {
    throw new Error("not implemented");
  };

export interface CVPortalCandidateToken {
  id: number | null;
  idConcern: number;
  idCandidate: number;
  token: string;
  hash: string;
  expires: string;
  added: string;
}

export interface CVPortalCandidateParsedToken {
  id: number | null;
  idConcern: number;
  idCandidate: number;
  token: string;
  hash: string;
  expires: string;
  added: string;
  parsed: {
    access_token: string;
    expires_in: number;
    scope: string;
    token_type: string;
  };
}
